<div *ngIf="form" [formGroup]="form">

    <label for="name">Name</label>
    <input type="text" class="form-control" formControlName="name" id="name">

    <!--Uploading an image-->
    <label class="btn btn-primary btn-block space" for="image">
        <i class="fas mr-2" [ngClass]="{
        'fa-file-image': !uploaded,
        'fa-check-circle': uploaded
        }"></i>{{uploaded ? 'Uploaded' : 'Upload image'}}
    </label>
    <!--Uploading an image trigger-->
    <input (change)="uploadImage($event.target.files)" accept=".png,.jpg" class="d-none" id="image" type="file" />
    <div *ngIf="error" class="error mt-2 mb-4">{{error}}</div>

    <label for="region">Region</label>
    <input type="text" class="form-control" formControlName="region" id="region">

    <label for="weight">Weight</label>
    <input type="number" class="form-control" formControlName="weight" id="weight">

    <label class="mb-3">Select item</label>
    <div class="row">
        <div class="col-6">
            <input (keyup)="filterItems($event.target.value)" type="text" class="form-control" placeholder="Search by name">
        </div>
        <div class="col-6">
            <select (change)="setItemsType($event.target.value)" class="form-control" name="type" placeholder="Search by type">
                <option value="" selected></option>
                <!--Fetching all types of an item (Food, Beverages, Useful)-->
                <option *ngFor="let type of itemService.types" [value]="type.toLocaleLowerCase()">{{type}}</option>
            </select>
        </div>
    </div>

    <!--Fetching all available items-->
    <div *ngIf="filteredItems" class="d-flex flex-wrap">
        <div *ngFor="let item of filteredItems; let i = index" class="mr-3 custom-control custom-checkbox">
            <input (change)="toggleItem(item.id)" class="custom-control-input m-0" type="checkbox" [value]="item.id" [id]="'item'+i" [checked]="itemAdded(item.id)">
            <label class="custom-control-label ml-2" [for]="'item'+i">{{item.name}}</label>
        </div>
    </div>
    <!--Submitting the form-->
    <button (click)="submitForm()" class="btn btn-primary btn-block mt-5" [disabled]="form.invalid">{{id ? 'Save' : 'Add'}} theme</button>
    <!--Cancellation-->
    <button (click)="ngOnInit()" class="btn btn-light btn-block mt-3">Cancel</button>

</div>
